import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  //todo expanded modal
  todoModalRoot: {
    /* minWidth: "500px",
    maxWidth: "800px", */
    width: "75%",
    "& .MuiFormHelperText-root": {
      color: "#ffcc00",
    },
  },

  taskCardsContainer: {
    backgroundColor: "#252A38",
    padding: "10px",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    height: "600px",
    overflowY: "auto",
    marginTop: "10px",
  },
  singleTaskCard: {
    backgroundColor: "#1B1D28",
    padding: "6px",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    cursor: "pointer",
  },
  singleTaskCardSelected: {
    backgroundColor: "#1B1D28",
    padding: "6px",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    border: `2px solid ${theme.palette.secondary.main}`,
    cursor: "pointer",
  },

  todoListContainer: {
    backgroundColor: "#252A38",
    padding: "10px",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginTop: "10px",
  },

  todoList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    height: "500px",
    overflowY: "auto",
  },
  card: {
    color: theme.palette.text.primary,
    borderRadius: "10px",
  },
  cardContent: {
    backgroundColor: theme.palette.primary.main,
    padding: "30px",
    position: "relative",
  },
  title: {
    color: theme.palette.text.primary,
    fontSize: "25px",
    fontWeight: "700",
  },
  closeIcon: {
    color: theme.palette.text.primary,
    cursor: "pointer",
  },

  imageInput: {
    opacity: 0,
    width: "100%",
    height: "100%",
  },
  iconStyle: {
    width: "100%",
    marginTop: "29%",
    color: theme.palette.text.primary,
  },

  cardContentDiv1: {
    justifyContent: "space-around",
    marginTop: "5%",
  },
  cardContentDiv2: {
    // width: "100%",
    // height: "4rem",
    // display: "grid",
    // placeItems: "right",
    // border: `2px solid ${theme.palette.text.primary}`,
    borderRadius: "10px",
  },

  cardContentDiv3: {
    backgroundColor: theme.palette.secondary.light,
    padding: "3px",
    borderRadius: "10px",
  },

  cardContentDiv4: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    padding: "3px",
    height: "10vh",
    width: "100%",
  },

  cardContentInput2: {
    width: "100% ",
    padding: "0px 4px",
    maxHeight: "100%",
    overflow: "hidden",
  },

  /* cardContentInput1: {
    padding: "0.2px 6px",
  }, */

  done: {
    backgroundColor: theme.palette.secondary.main,
    height: "40px",
    marginTop: "10px",
    textTransform: "none",
    padding: "6px ",
    borderRadius: "7px",
    color: theme.palette.text.secondary,
    "&:hover": {
      background: theme.palette.secondary.light,
      color: theme.palette.text.primary,
    },
  },

  cardAction: {
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    justifyContent: "center",
    paddingLeft: "0px",
    paddingRight: "0px",
  },

  labelText: {
    display: "block",
    borderRadius: "5px",
    color: theme.palette.text.tertiary,
    cursor: "pointer",
    textAlign: "center",
  },
  addNewStatusButton: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
  },

  //common styles

  spaceBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  flexAndGap4px: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },

  statusColor: {
    borderRadius: "50%",
    display: "inline-block",
    // margin: "0px 14px",
    height: "13px",
    width: "13px",
    border: "2px solid",
    borderColor: theme.palette.borderColor,
  },

  /* cardContentDiv2: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
  }, */

  cardContentInput1: {
    padding: "0.2px 10px",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    width: "100%",
    height: "40px",
    color: "white",
    cursor: "pointer",
  },
  grayText: {
    color: theme.palette.text.tertiary,
  },
}));

export default useStyles;
